import Image from 'next/image';
import IconThemePrimary from './copy_theme_primary.svg?url';
import IconWhite from './copy_white.svg?url';
import type { SvgImageProps } from '../types';

export const CopyThemePrimaryImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconThemePrimary} alt={alt} {...props} />;

export const CopyWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={IconWhite} alt={alt} {...props} />
);
